import { i18n, defaultNS, mergeResources } from "@whatslly/commons/i18nService";
import { AuthI18N } from "@whatslly/ui-components/Pages/Authi18n";
import { TuvisMessagingI18N } from "@whatslly/messaging-ui/Pages/TuvisMessaging/TuvisMessagingI18N";
import translationEN from "./en/translation.json";
import translationES from "./es/translation.json";
import translationPT from "./pt/translation.json";

i18n.addResources("en", defaultNS, mergeResources(AuthI18N.en, TuvisMessagingI18N.en, translationEN));
i18n.addResources("es", defaultNS, mergeResources(AuthI18N.es, TuvisMessagingI18N.es, translationES));
i18n.addResources("pt", defaultNS, mergeResources(AuthI18N.pt, TuvisMessagingI18N.pt, translationPT));

export default i18n;
